import { useEffect } from "react";
import { createGlobalStyle } from "styled-components";

const INPUT_MODALITY_ATTRIBUTE = "data-input-modality";

const NAVIGATION_KEYS = new Set([
  "Tab",
  "ArrowUp",
  "ArrowDown",
  "ArrowLeft",
  "ArrowRight",
  "Enter",
  " ",
]);

type InputModality = "pointer" | "keyboard";

export const PointerFocusStyle = createGlobalStyle`
  html[${INPUT_MODALITY_ATTRIBUTE}="pointer"] :focus-visible {
    outline: none !important;
  }
`;

const setInputModality = (modality: InputModality) =>
  document.documentElement.setAttribute(INPUT_MODALITY_ATTRIBUTE, modality);

const watchInputModality = () => {
  const onPointer = () => setInputModality("pointer");
  const onKey = (event: KeyboardEvent) => {
    if (NAVIGATION_KEYS.has(event.key)) setInputModality("keyboard");
  };
  window.addEventListener("pointerdown", onPointer, true);
  window.addEventListener("keydown", onKey, true);
  return () => {
    window.removeEventListener("pointerdown", onPointer, true);
    window.removeEventListener("keydown", onKey, true);
  };
};

export const useInputModality = (enabled: boolean) =>
  useEffect(() => (enabled ? watchInputModality() : undefined), [enabled]);
